/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { formatTimer } from '../utils/formatTimer'
import styles from './styles.module.css'

export const OfferBox = ({
  variant = 'solid',
  label,
  couponText,
  couponCode,
  couponValidityText,
  price,
  originalPrice,
  description,
  subdescription,
  unitPrice,
  timerSeconds,
  timerLabel,
  onTimerExpire,
}) => {
  const { t } = useTranslation()
  const resolvedCouponValidityText =
    couponValidityText ?? t('upsell.modals.coupon_validity')
  const resolvedTimerLabel = timerLabel ?? t('upsell.modals.offer_expires_in')
  const [remaining, setRemaining] = useState(timerSeconds)

  useEffect(() => {
    if (timerSeconds == null) return undefined

    setRemaining(timerSeconds)

    const interval = setInterval(() => {
      setRemaining((current) => {
        if (current <= 1) {
          clearInterval(interval)
          onTimerExpire?.()
          return 0
        }
        return current - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [timerSeconds, onTimerExpire])

  const variantClass =
    variant === 'dashed' ? styles.offerBoxDashed : styles.offerBoxSolid

  return (
    <div className={`${styles.offerBox} ${variantClass}`}>
      {label && <p className={styles.offerLabel}>{label}</p>}
      {couponCode ? (
        <p className={styles.offerCoupon}>
          <span className={styles.offerCouponMuted}>{t('upsell.modals.coupon_prefix')}</span>
          <span className={styles.offerCouponCode}>{couponCode}</span>
          <span className={styles.offerCouponMuted}>{resolvedCouponValidityText}</span>
        </p>
      ) : (
        couponText && (
          <p className={`${styles.offerCoupon} ${styles.offerCouponPlain}`}>
            {couponText}
          </p>
        )
      )}
      <div className={styles.offerPriceRow}>
        {originalPrice != null && (
          <p className={styles.offerOriginalPrice}>{originalPrice}</p>
        )}
        {price != null && <p className={styles.offerPrice}>{price}</p>}
      </div>
      {unitPrice && <p className={styles.offerUnitPrice}>{unitPrice}</p>}
      {description && <p className={styles.offerDescription}>{description}</p>}
      {subdescription && (
        <p className={styles.offerSubdescription}>{subdescription}</p>
      )}
      {timerSeconds != null && remaining > 0 && (
        <p className={styles.offerTimer}>
          {resolvedTimerLabel} {formatTimer(remaining)}
        </p>
      )}
    </div>
  )
}

export default OfferBox
